import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-floorStatus1",
  "use": "icon-floorStatus1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-floorStatus1\"><defs><style type=\"text/css\"></style></defs><path d=\"M141.5 447.9v61h74.7l-74.7 122 31.2 30.5 93.4-152.6h137l-74.8 122 31.2 30.5L453 508.9h137l-74.8 122 31.1 30.5 93.5-152.6h137l-74.7 122 31.1 30.5 93.4-152.6H889v-61H141.5z m0 0\" p-id=\"9258\" fill=\"#1afa29\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol